import { useState } from "react";
import { Badge } from "react-bootstrap";
import { useSelector } from "react-redux";
import { Translate } from "../../../../Enums/Tranlate";
import VacationExtensionService from "../../../../../services/HRM/VacationExtensionService";

const statusVariant = {
	approved: "success",
	rejected: "danger",
	pending: "warning",
	cancelled: "secondary",
};

const VacationExtensionCardItem = ({ item, index, onStatusChange }) => {
	const lang = useSelector((state) => state.auth?.lang);
	const [loadingStatus, setLoadingStatus] = useState(null);

	const handleStatus = (status) => {
		setLoadingStatus(status);
		new VacationExtensionService()
			.changeStatus(item.id, status)
			.then((res) => {
				if (res?.status === 200 || res?.status === 201) {
					onStatusChange(item.id, status);
				}
			})
			.finally(() => setLoadingStatus(null));
	};

	const statusKey = item?.status?.toLowerCase?.() || item?.status;
	const isPending = statusKey === "pending" || !item?.status;

	return (
		<tr key={index} className="text-center">
			<td>
				<strong>{item?.employee?.id}</strong>
			</td>
			<td>{item?.employee?.name}</td>
			<td>{item?.employee?.department?.name || "-"}</td>
			<td>
				{item?.vacation?.departureDay
					? item.vacation.departureDay.split("T")[0]
					: "-"}
			</td>
			<td>
				{item?.vacation?.returnDay
					? item.vacation.returnDay.split("T")[0]
					: "-"}
			</td>
			<td>{item?.extendToDate ? item.extendToDate.split("T")[0] : "-"}</td>
			<td>{item?.additionalDays ?? "-"}</td>
			<td>{item?.description || "-"}</td>
			<td>
				{item?.status ? (
					<Badge bg={statusVariant[statusKey] || "secondary"}>
						{Translate[lang]?.[statusKey] || item.status}
					</Badge>
				) : (
					"-"
				)}
			</td>
			<td>
				{item?.attachmentUrls?.length > 0
					? item.attachmentUrls.map((url, i) => (
							<a key={i} href={url} target="_blank" rel="noreferrer">
								<i className="la la-file-pdf" style={{ fontSize: "2rem" }} />
							</a>
						))
					: "-"}
			</td>
			<td>
				{isPending ? (
					<div className="d-flex justify-content-center gap-2">
						<button
							className="btn btn-success btn-xs py-1 px-2"
							disabled={!!loadingStatus}
							onClick={() => handleStatus("approve")}>
							{loadingStatus === "approve" ? (
								<span className="spinner-border spinner-border-sm" />
							) : (
								<>
									<i className="la la-check me-1" />
									{Translate[lang]?.approve}
								</>
							)}
						</button>
						<button
							className="btn btn-danger btn-xs py-1 px-2"
							disabled={!!loadingStatus}
							onClick={() => handleStatus("reject")}>
							{loadingStatus === "reject" ? (
								<span className="spinner-border spinner-border-sm" />
							) : (
								<>
									<i className="la la-times me-1" />
									{Translate[lang]?.reject}
								</>
							)}
						</button>
					</div>
				) : (
					"-"
				)}
			</td>
		</tr>
	);
};
export default VacationExtensionCardItem;
